import './App.css';
import Sidebar from './Sidebar';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useCookies } from 'react-cookie';
import './Main.css';
import Background from './Background';
import { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';

function BackgroundImages() {

    const [cookies] = useCookies(['user']);
    const [backgroundImages, setBackgroundImages] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [editingImage, setEditingImage] = useState(null);
    const [editForm, setEditForm] = useState({ image_url: '', site_url: '', enabled: true, opacity: 0.15, image: null });

    const getBackgroundImages = () => {
        setIsLoading(true);
        fetch('https://api.connecker.com/api/get_background_images', {
            method: 'POST'
        }).then(res => {
            setIsLoading(false);
            if(!res.ok) {
                throw Error('Could not fetch');
            }
            return res.json();
        }).then(data => {
            setIsLoading(false);
            if(data.response_code == 200) {
                setBackgroundImages(data.data);
            } else if(data.response_code == 404) {
                setBackgroundImages([]);
            }
        });
    }

    const deleteBackgroundImageAPI = (background_image_id) => {
        var data = new FormData();
        data.append("background_image_id", background_image_id);
        setIsLoading(true);
        fetch('https://api.connecker.com/api/delete_background_image', {
            method: 'POST',
            body: data,
            headers: {
                'Authorization': `Bearer ${cookies.token}`
            }
        }).then(res => {
            setIsLoading(false);
            if(!res.ok) {
                throw Error('Could not fetch');
            }
            return res.json();
        }).then(data => {
            setIsLoading(false);
            if(data.response_code == 200) {
                toast.success(data.message);
                getBackgroundImages();
            } else {
                toast.error(data.message || 'Failed to delete background image');
            }
        }).catch(() => {
            setIsLoading(false);
            toast.error('Failed to delete background image');
        });
    }

    const deleteBackgroundImage = (background_image_id) => {
        const result = window.confirm('Are you sure you want to delete this background image?');
        if (result) {
            deleteBackgroundImageAPI(background_image_id);
        }
    }

    const openEditModal = (image) => {
        setEditingImage(image);
        setEditForm({
            image_url: image.image_url || '',
            site_url: image.site_url || '',
            enabled: image.enabled !== undefined ? Boolean(image.enabled) : true,
            opacity: image.opacity !== undefined ? Number(image.opacity) : 0.15,
            image: null
        });
    };

    const closeEditModal = () => {
        setEditingImage(null);
    };

    const handleEditFormChange = (field, value) => {
        setEditForm(prev => ({ ...prev, [field]: value }));
    };

    const handleEditImageChange = (e) => {
        if (e.target.files && e.target.files[0]) {
            setEditForm(prev => ({ ...prev, image: e.target.files[0], image_url: '' }));
        }
    };

    const editBackgroundImageAPI = (e) => {
        e.preventDefault();
        if (!editingImage) return;
        var data = new FormData();
        data.append("background_image_id", String(editingImage.id));
        if (editForm.image) {
            data.append("image", editForm.image);
        } else if (editForm.image_url) {
            data.append("image_url", editForm.image_url);
        }
        data.append("site_url", editForm.site_url || '');
        data.append("enabled", String(editForm.enabled ? 1 : 0));
        data.append("opacity", String(editForm.opacity));
        setIsLoading(true);
        fetch('https://api.connecker.com/api/update_background_image', {
            method: 'POST',
            body: data,
            headers: {
                'Authorization': `Bearer ${cookies.token}`
            }
        }).then(res => res.json()).then(data => {
            setIsLoading(false);
            if (data.response_code === 200) {
                toast.success(data.message);
                closeEditModal();
                getBackgroundImages();
            } else {
                toast.error(data.message || 'Failed to update background image');
            }
        }).catch(() => {
            setIsLoading(false);
            toast.error('Failed to update background image');
        });
    };

    useEffect(() => {
        getBackgroundImages();
    }, []);

    return(
        <div className="content">
            <div className="row justify-content-start">
                <div className="col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2">
                    <Sidebar></Sidebar>
                </div>
                <div className="col-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 col-xxl-10" style={{ paddingLeft: "40px" }}>
                    <Background></Background>
                    <div className="d-flex justify-content-between align-items-center" style={{ marginTop: "50px" }}>
                        <h4 className="heading" style={{ color:"white" }}>Background Images</h4>
                        <Link to="/add_background_image">
                            <button 
                                className="btn"
                                style={{
                                    backgroundColor: "#FF4500",
                                    color: "white",
                                    border: "1px solid #FF4500",
                                    borderRadius: "25px",
                                    padding: "10px 20px",
                                    fontWeight: "500"
                                }}
                            >
                                Add Background Image
                            </button>
                        </Link>
                    </div>
                    
                    <div className="card" style={{ borderColor:"white", marginTop: "20px" }}>
                        <div className="table-responsive">
                            <table style={{ width:"100%" }} className="table table-striped">
                                <thead style={{ backgroundColor: "#f8f9fa" }}>
                                    <tr style={{ borderBottom: "2px solid #dee2e6" }}>
                                        <th style={{ color: "#666", fontWeight: "600", fontSize: "14px", padding: "12px 8px" }}>#</th>
                                        <th style={{ color: "#666", fontWeight: "600", fontSize: "14px", padding: "12px 8px" }}>PREVIEW</th>
                                        <th style={{ color: "#666", fontWeight: "600", fontSize: "14px", padding: "12px 8px" }}>IMAGE URL</th>
                                        <th style={{ color: "#666", fontWeight: "600", fontSize: "14px", padding: "12px 8px" }}>SITE URL</th>
                                        <th style={{ color: "#666", fontWeight: "600", fontSize: "14px", padding: "12px 8px" }}>OPACITY</th>
                                        <th style={{ color: "#666", fontWeight: "600", fontSize: "14px", padding: "12px 8px" }}>STATUS</th>
                                        <th style={{ color: "#666", fontWeight: "600", fontSize: "14px", padding: "12px 8px" }}>ACTIONS</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        backgroundImages.length === 0 ? (
                                            <tr>
                                                <td colSpan="7" style={{ padding: "40px", textAlign: "center", color: "#999" }}>
                                                    No background images found
                                                </td>
                                            </tr>
                                        ) : (
                                            backgroundImages.map((image, i) => (
                                                <tr key={image.id} style={{ borderBottom: "1px solid #eee" }}>
                                                    <td style={{ padding: "12px 8px", fontSize: "14px", color: "#333" }}>
                                                        {i+1}
                                                    </td>
                                                    <td style={{ padding: "12px 8px" }}>
                                                        {image.image_url ? (
                                                            <img 
                                                                src={image.image_url}
                                                                alt="Background"
                                                                style={{
                                                                    width: "120px",
                                                                    height: "70px",
                                                                    objectFit: "cover",
                                                                    borderRadius: "8px"
                                                                }}
                                                            />
                                                        ) : (
                                                            <span style={{ color: "#999", fontStyle: "italic" }}>No preview</span>
                                                        )}
                                                    </td>
                                                    <td style={{ padding: "12px 8px", fontSize: "14px", color: "#333", maxWidth: "200px", wordBreak: "break-all" }}>
                                                        {image.image_url ? (
                                                            <a href={image.image_url} target="_blank" rel="noopener noreferrer" style={{ color: "#007bff", textDecoration: "none" }}>
                                                                {image.image_url.length > 40 ? image.image_url.substring(0, 40) + '...' : image.image_url}
                                                            </a>
                                                        ) : '-'}
                                                    </td>
                                                    <td style={{ padding: "12px 8px", fontSize: "14px", color: "#333", maxWidth: "200px", wordBreak: "break-all" }}>
                                                        {image.site_url ? (
                                                            <a href={image.site_url} target="_blank" rel="noopener noreferrer" style={{ color: "#007bff", textDecoration: "none" }}>
                                                                {image.site_url.length > 40 ? image.site_url.substring(0, 40) + '...' : image.site_url}
                                                            </a>
                                                        ) : (
                                                            <span style={{ color: "#999", fontStyle: "italic" }}>—</span>
                                                        )}
                                                    </td>
                                                    <td style={{ padding: "12px 8px", fontSize: "14px", color: "#333" }}>
                                                        <span style={{
                                                            padding: "4px 12px",
                                                            backgroundColor: "#e9ecef",
                                                            borderRadius: "12px",
                                                            color: "#495057",
                                                            fontSize: "12px",
                                                            fontWeight: "500",
                                                            display: "inline-block"
                                                        }}>
                                                            {Number(image.opacity) || 0.15}
                                                        </span>
                                                    </td>
                                                    <td style={{ padding: "12px 8px", fontSize: "14px", color: "#333" }}>
                                                        <span style={{
                                                            padding: "4px 12px",
                                                            backgroundColor: image.enabled ? "#d4edda" : "#f8d7da",
                                                            borderRadius: "12px",
                                                            color: image.enabled ? "#155724" : "#721c24",
                                                            fontSize: "12px",
                                                            fontWeight: "500",
                                                            display: "inline-block",
                                                            textAlign: "center"
                                                        }}>
                                                            {image.enabled ? "Enabled" : "Disabled"}
                                                        </span>
                                                    </td>
                                                    <td style={{ padding: "12px 8px" }}>
                                                        <button 
                                                            className="btn btn-sm me-1"
                                                            onClick={() => openEditModal(image)}
                                                            style={{
                                                                backgroundColor: "#0d6efd",
                                                                borderColor: "#0d6efd",
                                                                color: "white",
                                                                fontSize: "12px",
                                                                padding: "6px 12px",
                                                                borderRadius: "6px"
                                                            }}
                                                        >
                                                            Edit
                                                        </button>
                                                        <button 
                                                            className="btn btn-sm"
                                                            onClick={() => deleteBackgroundImage(image.id)}
                                                            style={{
                                                                backgroundColor: "#dc3545",
                                                                borderColor: "#dc3545",
                                                                color: "white",
                                                                fontSize: "12px",
                                                                padding: "6px 12px",
                                                                borderRadius: "6px"
                                                            }}
                                                        >
                                                            Delete
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            {/* Edit Background Image Modal */}
            {editingImage && (
                <div className="modal fade show d-block" style={{ backgroundColor: "rgba(0,0,0,0.5)" }} tabIndex="-1">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Edit Background Image</h5>
                                <button type="button" className="btn-close" onClick={closeEditModal} aria-label="Close"></button>
                            </div>
                            <form onSubmit={editBackgroundImageAPI}>
                                <div className="modal-body">
                                    <div className="mb-3">
                                        <label className="form-label">Image (upload new to replace, or enter URL)</label>
                                        <input
                                            type="file"
                                            className="form-control mb-2"
                                            accept="image/jpeg,image/jpg,image/png,image/gif,image/webp"
                                            onChange={handleEditImageChange}
                                        />
                                        {editForm.image && (
                                            <div className="mb-2">
                                                <img 
                                                    src={URL.createObjectURL(editForm.image)} 
                                                    alt="Preview" 
                                                    style={{ maxWidth: "200px", maxHeight: "120px", objectFit: "cover", borderRadius: "8px" }}
                                                />
                                                <button 
                                                    type="button" 
                                                    className="btn btn-sm btn-outline-secondary ms-2"
                                                    onClick={() => handleEditFormChange('image', null)}
                                                >
                                                    Remove file
                                                </button>
                                            </div>
                                        )}
                                        <input
                                            type="url"
                                            className="form-control"
                                            placeholder="https://example.com/image.jpg (or leave empty to keep current)"
                                            value={editForm.image_url}
                                            onChange={(e) => handleEditFormChange('image_url', e.target.value)}
                                            disabled={!!editForm.image}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Site URL (optional)</label>
                                        <input
                                            type="url"
                                            className="form-control"
                                            placeholder="https://example.com"
                                            value={editForm.site_url}
                                            onChange={(e) => handleEditFormChange('site_url', e.target.value)}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Opacity (0–1)</label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            step="0.01"
                                            min="0"
                                            max="1"
                                            value={editForm.opacity}
                                            onChange={(e) => handleEditFormChange('opacity', parseFloat(e.target.value) || 0.15)}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Enabled</label>
                                        <select
                                            className="form-select"
                                            value={editForm.enabled ? 1 : 0}
                                            onChange={(e) => handleEditFormChange('enabled', e.target.value === '1')}
                                        >
                                            <option value={1}>Enabled</option>
                                            <option value={0}>Disabled</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={closeEditModal}>Cancel</button>
                                    <button type="submit" className="btn btn-primary" disabled={isLoading}>
                                        {isLoading ? 'Saving...' : 'Save changes'}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}

            <ToastContainer />
        </div>
    )
}

export default BackgroundImages;
